import { registerComponent } from '@gig/magic-common';
export { UploadStatus } from './file-upload.js';
import FileUploadComponent from './file-upload.vue.js';

var FileUpload = registerComponent(FileUploadComponent);

export { FileUpload };
